export default {
  computed: {
    orderedTags() {
      // tags = ['a', 'b', 'c', 'c', 'b', 'c']
      // [...groupedTags] => [
      //   ['a', ['a']],
      //   ['b', ['b', 'b']],
      //   ['c', ['c', 'c', 'c']],
      // ]
      let groupedTags = Map.groupBy(this.tags, (tag) => tag);

      return [...groupedTags]
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map((tag) => {
          let tagName = tag[0];
          if (tag[1].length > 1) {
            tagName += `(${tag[1].length})`;
          }
          return tagName;
        });
    },
  },
}
